import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/cover-letter-generator')({
  ssr: false, // CSR only - no SEO needed
})
